import { jsx as _jsx } from "react/jsx-runtime";
import { TextLink } from '@wit-support/ui';
/**
 * Ссылка в Ads Manager (новая вкладка; значок «внешняя ссылка» рисует сам
 * `TextLink external`). Нет адреса — ничего. Подпись не переносится — значок
 * всегда в строке с текстом; `compact` — короткая подпись для ячейки таблицы
 * (полная — в `title`).
 */
export function AdsManagerLink({ href, label = 'Ads Manager', compact = false, className, }) {
    if (href == null || href === '')
        return null;
    return (_jsx(TextLink, { href: href, external: true, title: compact ? 'Открыть в Ads Manager' : undefined, className: `whitespace-nowrap ${compact ? 'text-sm' : ''} ${className ?? ''}`.trim(), children: label }));
}
//# sourceMappingURL=ads-manager-link.js.map